module.exports = __webpack_public_path__ + "static/media/rbk.47957d9c.png";